import { useState } from 'react'
import { ChromePicker, type ColorResult } from 'react-color'

interface ColorPickerProps {
	value: string
	onChange: (color: string) => void
	placeholder?: string
}

export function ColorPicker({ value, onChange, placeholder = '#000000' }: ColorPickerProps) {
	const [isOpen, setIsOpen] = useState(false)

	const handleChange = (color: ColorResult) => {
		onChange(color.hex)
	}

	return (
		<div className='relative'>
			<button
				type='button'
				onClick={() => setIsOpen(!isOpen)}
				className='w-full flex items-center gap-2 p-2 rounded border border-neutral-200 hover:border-primary-500 transition-colors'>
				<div className='w-8 h-8 rounded border border-neutral-100' style={{ backgroundColor: value || placeholder }} />
				<div className='text-sm text-neutral-600 flex-1 text-left'>{value || placeholder}</div>
			</button>
			{isOpen && (
				<div className='absolute z-50 mt-2'>
					{/* biome-ignore lint/a11y/noStaticElementInteractions: presentation container for event bubbling */}
					<div
						role='presentation'
						className='fixed inset-0'
						onClick={() => setIsOpen(false)}
						onKeyDown={(e) => e.stopPropagation()}
					/>
					<div className='relative'>
						<ChromePicker
							color={value || placeholder}
							onChange={handleChange}
							disableAlpha={false}
							styles={{
								default: {
									picker: {
										boxShadow: '0 2px 10px rgba(0, 0, 0, 0.12), 0 2px 5px rgba(0, 0, 0, 0.16)',
										borderRadius: '4px',
									},
								},
							}}
						/>
					</div>
				</div>
			)}
		</div>
	)
}
